export const GAUGE_VARIANTS = [
    { id: 'speedometer', label: 'Speedometer Dial', icon: 'fas fa-tachometer-alt' },
    { id: 'arc', label: 'Arc Meter', icon: 'fas fa-adjust' },
    { id: 'ring', label: 'Ring Meter', icon: 'fas fa-circle-notch' },
    { id: 'radial-full', label: 'Radial Bar (Full)', icon: 'fas fa-dot-circle' },
    { id: 'radial-half', label: 'Radial Bar (Half)', icon: 'fas fa-record-vinyl' },
    { id: 'bar-horizontal', label: 'Bar Meter (Horizontal)', icon: 'fas fa-align-left' },
    { id: 'bar-vertical', label: 'Bar Meter (Vertical)', icon: 'fas fa-thermometer-half' },
    { id: 'digital', label: 'Digital Readout', icon: 'fas fa-digital-tachograph' },
    { id: 'led', label: 'Segmented LED Meter', icon: 'fas fa-signal' },
    { id: 'badge', label: 'Badge Meter', icon: 'fas fa-certificate' },
];
